module.exports = __webpack_public_path__ + "static/img/bg_btn1.24b3424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/bg_btn1.png
// module id = B2iK
// module chunks = 4